import React, { createContext, forwardRef, useContext, useState } from "react";
import MUIDialog from "@mui/material/Dialog";
import { getClassName } from "@sscs/utils";
import { CloseFullscreenIcon as CloseFullscreen, FullscreenIcon as Fullscreen, ChevronDownIcon as KeyboardArrowDown, ChevronUpIcon as KeyboardArrowUp, } from "../../icons";
import { Collapse, ExpandButton, IconButton } from "../index";
import styles from "./expandedCard.module.scss";
const CardContext = createContext({
    isExpanded: false,
    showSummary: true,
});
const Card = forwardRef(({ id, isExpanded, isFocused, disableFullscreen = false, className, onChange, onFocus, children, }, ref) => {
    const [hasSummary, setHasSummary] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [title, summary, details] = children;
    const showFullscreen = isFullscreen && isExpanded;
    const showSummary = showFullscreen ? hasSummary : true;
    if (!isExpanded && isFullscreen) {
        setIsFullscreen(false);
        setHasSummary(true);
    }
    const handleFullscreenChange = (fullscreen) => {
        onChange(fullscreen);
        setHasSummary(true);
        setIsFullscreen(fullscreen);
    };
    const card = (React.createElement(CardContext.Provider, { value: { isExpanded, showSummary } },
        React.createElement("div", { ref: ref, className: getClassName(styles["card-wrapper"], className, {
                [styles["card-wrapper-focused"]]: isFocused && isExpanded,
            }), onClick: () => onFocus() },
            React.createElement("div", { className: getClassName(styles["card-content"], {
                    [styles["card-content-expanded"]]: isExpanded,
                }) },
                !showFullscreen && (React.createElement(ExpandButton, { id: id, isExpanded: isExpanded, onClick: () => onChange(!isExpanded), "aria-label": "expand card", className: styles["expand-offset"] })),
                React.createElement("div", { className: styles["summary-title-wrapper"] },
                    title,
                    showSummary ? summary : null),
                showFullscreen && (React.createElement(IconButton, { id: id, size: "small", onClick: () => setHasSummary(!hasSummary), "aria-label": "show/hide summary", className: styles["toggle-summary"] }, hasSummary ? React.createElement(KeyboardArrowUp, null) : React.createElement(KeyboardArrowDown, null)))),
            details,
            !disableFullscreen && (React.createElement(IconButton, { size: "small", onClick: () => handleFullscreenChange(!showFullscreen), "aria-label": "toggle fullscreen", className: styles["expand-to-fullscreen"] }, showFullscreen ? React.createElement(CloseFullscreen, null) : React.createElement(Fullscreen, null))))));
    return showFullscreen ? (React.createElement(MUIDialog, { PaperProps: { "aria-label": "expanded card" }, open: showFullscreen, maxWidth: false, onClose: () => handleFullscreenChange(false), classes: { paper: styles.dialog } }, card)) : (card);
});
Card.displayName = "Card";
const Title = ({ className, children }) => {
    const { showSummary } = useContext(CardContext);
    return (React.createElement("div", { className: getClassName(styles["title-role"], { [styles.title]: showSummary }, className) }, children));
};
const Summary = ({ className, children }) => {
    return React.createElement("div", { className: className }, children);
};
const Details = ({ className, children }) => {
    const { isExpanded } = useContext(CardContext);
    return (React.createElement(Collapse, { transitionIn: isExpanded },
        React.createElement("div", { className: getClassName(styles.details, className) }, children)));
};
export default { Card, Details, Summary, Title };
//# sourceMappingURL=ExpandedCard.js.map